import { useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { plur } from "@/lib/format";

// 216: pokračování stránkovaného seznamu (Galerie, fotobanka zakázky).
// Neviditelná zarážka pod seznamem načte další stránku sama, jakmile se k ní
// uživatel doposouvá (mobil i desktop). Tlačítko pod ní je záloha — kdyby
// prohlížeč IntersectionObserver neuměl, nebo se načtení nepovedlo.
export function LoadMore({ hasMore, loading, onMore, shown, total, entity = ["fotka", "fotky", "fotek"], testid = "load-more" }) {
  const ref = useRef(null);
  const moreRef = useRef(onMore);
  moreRef.current = onMore;

  useEffect(() => {
    const el = ref.current;
    if (!el || !hasMore || typeof IntersectionObserver === "undefined") return undefined;
    const io = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) moreRef.current?.();
    }, { rootMargin: "800px 0px" });
    io.observe(el);
    return () => io.disconnect();
  }, [hasMore, shown]);

  if (!hasMore) return null;
  const rest = Math.max(0, (total || 0) - (shown || 0));
  return (
    <div ref={ref} className="flex flex-col items-center gap-1.5 pt-4" data-testid={testid}>
      <Button variant="outline" className="h-11 rounded-full w-full md:w-auto" disabled={loading}
        onClick={() => onMore?.()} data-testid={`${testid}-btn`}>
        {loading ? "Načítám…" : rest ? `Načíst další (zbývá ${plur(rest, ...entity)})` : "Načíst další"}
      </Button>
      {shown != null && total != null && (
        <span className="text-xs text-muted-foreground tabular-nums" data-testid={`${testid}-count`}>
          Zobrazeno {shown} z {total}
        </span>
      )}
    </div>
  );
}
